// @flow

import React, { Component } from "react";
import "./styles.css";
import uuid from "uuid";
import withValidation from "../with-validation";

const removeTag = Symbol("@@_REMOVE_TAG");
const addTag = Symbol("@@_ADD_TAG");

const type = "text";
const excludedProps = ["children", "className", "errorMessage", "isError", "labelText", "tags", "value"];

/**
 * removes a tag and updates value
 * @param {string} tag - tag to remove
 * @returns {Function} - remove function
 * @private
 */
function _removeTag(tag: string): any => void {
    return (
        () => {
            const newTags = this.props.value.filter(val => val.toLowerCase() !== tag.toLowerCase());
            this.props.onChange(newTags);
        }
    );
}


/**
 * adds a tag and updates value
 * @param {string} tag - tag to add
 * @returns {void}
 * @private
 */
function _addTag(tag: string): any => void {
    const newTags = [].concat(this.props.value, tag.trim().split(" ").map(word => `${word.slice(0, 1).toUpperCase()}${word.slice(1).toLowerCase()}`).join(" "));
    this.setState({ newTag: "" }, () => this.props.onChange(Array.from(new Set(newTags))));
}

type Props = {
    id: ?string,
    className: ?string,
    data: ?Array<string>,
    disabled: ?boolean,
    errorMessage: ?string,
    isError: ?boolean,
    onChange: any => any,
    labelText: ?string,
    readOnly: ?boolean,
    required: ?boolean,
    style: ?Object,
    tags: ?Array<string>,
    value: ?string
};

const filterProps = (_props: any): any => ({
    ...Object.keys(_props)
        .filter(key => excludedProps.indexOf(key) === -1)
        .reduce((obj, key) => ({ ...obj, [key]: _props[key] }), {}),
    type,
    id: _props.id || uuid()
});


class Tags extends Component<Props> {

    static defaultProps = {
        disabled: false,
        isError: false,
        required: false,
        errorMessage: "Error",
        readOnly: false,
        tags: [],
        value: []
    };

    constructor(props) {
        super(props);
        this[removeTag] = _removeTag.bind(this);
        this[addTag] = _addTag.bind(this);
        this.state = { value: "" };
    }


    render() {
        const { disabled, errorMessage, className, isError, labelText, readOnly, required, value } = this.props;
        const componentClass = `tags${required ? " is-required" : ""}${isError ? " is-error" : ""}${disabled ? " is-disabled" : ""}${readOnly ? " is-read-only" : ""}${className ? ` ${className}` : ""}`;
        const inputProps = filterProps(this.props);
        const tagBoxes = (value || []).map(tag => (
            <span className={ "tags--tag-span" } key={ tag }>
                <button className={ "tags--remove-button" } onClick={ this[removeTag](tag) }/>
                {tag}
            </span>
        ));
        return (
            <label
                className={ componentClass }
                htmlFor={ inputProps.id }
            >
                <span className="tags--label-text">{labelText || "Tags: "}</span>
                <span className={ "tags--error-message" }>{errorMessage}</span>
                <span className={ "tags--control" }>
                    <span className={ "tags--tag-boxes" }>{tagBoxes}</span>
                    <span className={ "tags--new-tag" }>
                        <span className={ "tags--new-tag-wrapper" }>
                            <input
                                { ...inputProps }
                                onChange={ (event) => {
                                    this.setState({ newTag: event.target.value });
                                } }
                                onKeyPress={ (event) => {
                                    if (event.key === "Enter") {
                                        this[addTag](this.state.newTag);
                                    }
                                } }
                                value={ this.state.newTag || "" }
                            />
                            <button className={ "tags--add-button" } onClick={ () => this[addTag](this.state.newTag) }/>
                        </span>
                    </span>
                </span>
            </label>
        );
    }
}


export default withValidation(Tags);